// leadTransform já devolve temperatureColor como cor do tema ('temperatureHot' |
// 'temperatureWarm' | 'temperatureCold' | 'default'), então a faixa superior do
// card sai da própria paleta.
export const getLeadCardBorderColor = (lead, theme) => {
  const palette = (theme.vars || theme).palette;
  if (lead.readOnly) return palette.action.disabled;
  return palette[lead.temperatureColor]?.main || palette.text.disabled;
};
